import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranService, TransactionId, TranType, PrInTransaction } from '../../services/tran.service';
import { Subscription } from 'rxjs';
import { Utils } from '../../util';
import { NgTable } from '../../coms';
import { PrVntaId, ProductVntaService } from '../../services/product-vnta.service';
import { PrCmpaId, ProductCmpaService } from '../../services/product-cmpa.service';
import { Globals } from '../../globals';
import { UnitService, UnitId } from '../../services/unit.service';
import { ProductionOrderService, ProductionOrderId } from '../../services/production-order.service';

@Component({
  selector: 'app-read-all-tran',
  templateUrl: './read-all-tran.component.html',
  styleUrls: ['./read-all-tran.component.css']
})
export class ReadAllTranComponent implements OnInit, OnDestroy {
  loading: boolean[] = [false, false];
  get loaded(): boolean { return !this.loading.includes(false); }

  trans: TransactionId[];
  table: NgTable;

  cat: string = 'Todas';
  catSelect: string[] = [this.cat];
  pr: string = 'Todos';
  prSelect: string[] = [this.pr];

  prVntas: {[s: string]: PrVntaId} = {};
  prCmpas: {[s: string]: PrCmpaId} = {};
  units: {[id: string]: UnitId['symbol']} = {};
  odps: {[id: string]: ProductionOrderId} = {};

  sub: Subscription;
  prCmpaSub: Subscription;
  prVntaSub: Subscription;
  unitSub: Subscription;
  odpSub: Subscription;

  constructor(
    private service: TranService,
    private prCmpaService: ProductCmpaService,
    private prVntaService: ProductVntaService,
    private unitService: UnitService,
    private odpService: ProductionOrderService,
  ) {
    this.unitSub = this.unitService.getUnits().subscribe(units => {
      units.map(unit => {
        this.units[unit.id] = unit.symbol;
        //this.units[`Name of: ${unit.id}`] = unit.name;
        if(!this.prCmpaSub) this.prCmpaSub = this.prCmpaService.getPrCmpas().subscribe(prCmpas => {
          this.prCmpas = prCmpas.reduce((acc, cur) => ({...acc, [cur.id]: cur}), {});
    
          if(!this.prVntaSub) this.prVntaSub = this.prVntaService.getPrVntas().subscribe(prVntas => {
            this.prVntas = prVntas.reduce((acc, cur) => ({...acc, [cur.id]: cur}), {});

            if(!this.odpSub) this.odpSub = this.odpService.getProductionOrders().subscribe(odps => {
              this.odps = odps.reduce((acc, cur) => ({...acc, [cur.id]: cur}), {});

              this.loading[0] = true;
              this.getTable();
            });
          });
        });
      });
    });
    
    
  }

  ngOnInit() {
    //this.service.windowReplace.home();
  }
  ngOnDestroy(){
     if(this.sub) this.sub.unsubscribe();
     this.sub = undefined;
     if(this.prCmpaSub) this.prCmpaSub.unsubscribe();
     this.prCmpaSub = undefined;
     if(this.prVntaSub) this.prVntaSub.unsubscribe();
     this.prVntaSub = undefined;
     if(this.unitSub) this.unitSub.unsubscribe();
     this.unitSub = undefined;
  }

  getTable(){
    this.loading[1] = false;
    if(this.sub) this.sub.unsubscribe();
    this.sub = this.service.getTransactions().subscribe(trans => {
      this.trans = trans.reduce((acc, tran: any) => {
        if(tran.canceled) return acc;
        tran.type = tran.type == TranType.In ? 'Entrada' : 'Salida';
        tran.cat = Utils.cleanPush(this.catSelect, tran.inOutTypeObj.description);
        tran.warehouse = tran.warehouseObj.name;
        let prs = tran.prInTransaction.map(({odpId, quantity, ref}: PrInTransaction) => {
          let {name: prName, code: prCode, characs: chs} = (ref.parent.id == Globals.PRCMPA_COLLECTION ? this.prCmpas[ref.id] : this.prVntas[ref.id]) || {name: Globals.PR_DELETED, code: 'N.A.', characs: []};
          let characs: string = (<any>chs).reduce((acc: string, cur, index) => `${acc}${index ? ', ' : ''}${cur.name.charAt(0)} ${cur.value}${this.units[cur.unitId.id] ? ` ${this.units[cur.unitId.id]}` : ''}`, '');
          Utils.cleanPush(this.prSelect, prName);
          prName = `${prName}${ characs ? ` - ${characs}` : ''}`
          //let prQuan = `${quantity || 0}, $${Utils.money(cost || 0)}`;
          let prQuan = quantity || 0;
          let orderName = odpId && this.odps[odpId] && this.odps[odpId].name || 'N.A.';
          if(prCode == 'CR-0018') console.log(prName, ref.id)
          return {folio: '', prName, prCode, prQuan, orderName, ...tran};
        })
        return [...acc, ...prs];
      }, []);

      this.loading[1] = true;
      this.applyTable();
    });
  }
  applyTable(){
    //console.log(1, this.trans);
    let {columns, trans} = this;
    //trans.map(({cat, prName}: any) => console.log(this.pr == 'Todos', this.pr.split(' - ')[0], == prName) );
    let data = trans.filter(({cat, prName}: any) => (this.cat == 'Todas' || this.cat == cat) && (this.pr == 'Todos' || this.pr == prName.split(' - ')[0]) );
    this.table = new NgTable({columns, data, itemsPerPage: 15});
  }

  get quantitySum(): number {
    let sum = 0;
    for(let row of this.table.rows){
      //console.log(`${sum} + ${row.prQuan} = ${+row.prQuan + sum}`);
      sum += +row.prQuan;
    }
    return sum;
  }


  columns:Array<any> = [
    {title: 'Fecha', name: "date", sort: 'desc'},
    {title: 'Producto', name: "prName"},
    {title: 'Código', name: "prCode"},
    {title: 'Cantidad', name: "prQuan"},
    {title: 'Folio', name: "folio"},
    {title: 'Almacén', name: 'warehouse'},
    {title: 'Tipo', name: 'type'},
    {title: 'Categoria', name: 'cat'},
    {title: 'Orden de producción', name: 'orderName'},
    {title: 'Observaciones', name: 'observations'},
  ];

}
